import { PipeTransform, Pipe } from '@angular/core';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'mlc' })
export class MultiLanguageComplexPipe implements PipeTransform {
	constructor(
		public ml: MultiLanguageService,
		public translate: TranslateService
	) { 

	}

	transform(label,trigger) {
		var returnLabel = label;

		try	{
			let newLabel = label.replace(/'/g, '"');

			var json = JSON.parse(newLabel);

			var values = this.formatValues(json);

			this.translate.get(json.mainsString)
			.subscribe(translations => {
				values.forEach((value)=>{
					var key = Object.keys(value);

					translations = translations.replace("{{" + key[0] + "}}", value[key[0]])
				});

				returnLabel = translations;
			});
		}catch(e){
			let i = e;
		}

		return returnLabel;
	}

	formatValues(json){
		json.clientTranslateValues.forEach((item)=>{
			json.data.push({
				"value": this.ml.translateLabel(item.value), 
				"name": item.name
			});
		});

		var reformated = [];

		json.data.forEach((item)=>{
			var data = {};

			data[item.name] = item.value;

			reformated.push(data);
		})

		return reformated;
	}
}